import * as React from 'react';
import { Box, Card, CardActions, Button, Typography } from '@mui/material';
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';
import GitHubIcon from '@mui/icons-material/GitHub';
import BookIcon from '@mui/icons-material/Book';
import SupportIcon from '@mui/icons-material/Support';

import publishArticleImage from './welcome_illustration.svg';

const Welcome = ({ userName }) => {

    return (
        <Card
            sx={{
                background: theme =>
                    theme.palette.mode === 'dark'
                        ? '#535353'
                        : `linear-gradient(to right, #8975fb 0%, #746be7 35%), linear-gradient(to bottom, #8975fb 0%, #6f4ceb 50%), #6f4ceb`,

                color: '#fff',
                padding: '20px',
                marginTop: 2,
                // marginBottom: '1em',
            }}
        >
            <Box display="flex">
                <Box flex="1">
                    <Typography variant="h5" component="h2" gutterBottom>
                        Welcome {userName ? `${userName} ` : ''}to DeepBlock !
                    </Typography>
                    <Box maxWidth="55em">
                        <Typography variant="body1" component="p" gutterBottom>
                            A Deep Learning Approach for Rational Ligand Generation with Property Control via Reactive Building Blocks
                        </Typography>
                    </Box>
                    <CardActions
                        sx={{
                            padding: { xs: 0, xl: null },
                            flexWrap: { xs: 'wrap', xl: null },
                            '& a': {
                                marginTop: { xs: '1em', xl: null },
                                marginLeft: { xs: '0!important', xl: null },
                                marginRight: { xs: '1em', xl: null },
                            },
                        }}
                    >
                        <Button
                            variant="contained"
                            href="https://www.molmatrix.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<DatasetLinkedIcon />}
                        >
                            MolMatrix
                        </Button>
                        <Button
                            variant="contained"
                            href="https://github.com/BioChemAI/DeepBlock"
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<GitHubIcon />}
                        >
                            GitHub
                        </Button>
                        <Button
                            variant="contained"
                            href="https://doi.org/10.1038/s43588-024-00718-0"
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<BookIcon />}
                        >
                            Paper
                        </Button>
                        <Button
                            variant="contained"
                            href="https://www.pizyds.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<SupportIcon />}
                        >
                            Support
                        </Button>
                    </CardActions>
                </Box>
                <Box
                    display={{ xs: 'none', sm: 'none', md: 'block' }}
                    sx={{
                        background: `url(${publishArticleImage}) top right / cover`,
                        marginLeft: 'auto',
                    }}
                    width="16em"
                    height="9em"
                    overflow="hidden"
                />
            </Box>
        </Card>
    );
};

export default Welcome;
